export default class Thing {
	successor() { return this }
	get blocking()  { return false }
	get obscuring() { return false }
}



/** WEBPACK FOOTER **
 ** ./src/things/Thing.es6.js
 **/